/*
 * This is the initial API interface
 * we set the base URL for the API
 */

import axios from 'axios';
import Vue from 'vue';

const apiClient = axios.create({
    baseURL: '/',
    withCredentials: true, // required to handle the CSRF token
});

/*
 * Add a response interceptor
 */
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        const { status } = error.response;

        if ([401, 419].includes(status)) {
            // eslint-disable-next-line no-undef
            Vue.swal({
                type: 'warning',
                title: 'Session har förfallit!',
                text: 'Logga in på nytt för att fortsätta.',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-primary',
                cancelButtonClass: 'btn btn-light',
                reverseButtons: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'Avbryt',
            }).then(() => {
                // store.dispatch('auth/unsetuserandredirect');
            });
        } else if ([403].includes(status)) {
            // eslint-disable-next-line no-undef
            Vue.swal({
                type: 'warning',
                title: 'Obehörig!',
                text: 'Du har inte rättigheter att utföra denna åtgärd.',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-primary',
                cancelButtonClass: 'btn btn-light',
                reverseButtons: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'Avbryt',
            });
        } else if (status >= 400 && status !== 422) {
            const { data } = error.response;
            let message = 'Oops... Något gick fel...';
            if (data.message) {
                message = data.message;
            }
            // eslint-disable-next-line no-undef
            Vue.swal({
                type: 'error',
                title: 'Error!',
                text: message,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-primary',
                cancelButtonClass: 'btn btn-light',
                reverseButtons: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'Avbryt',
            });
        }

        return Promise.reject(error);
    },
);

export default apiClient;
